module.exports = __webpack_public_path__ + "static/img/img-06.d367e6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-06.jpg
// module id = 89
// module chunks = 0